import memoize from "fast-memoize";
import { encrypt, decrypt } from "./crypto";

const ACCESS_TOKEN = "token";
const TOKEN_ENCRYPT_KEY = "EA@ContaUnica!@#";
const memoizeCache = new Map();

/**
 * Armazena o objeto de Sessão no sessionStorage para permitir o compartilhamento do mesmo entre as abas do browser.
 * Usar o sessionStore implica que a informação adicionada nele só é válida na aba do browser em que foi gerado.
 * Como mecanismo de proteção, criptografamos as informações de Sessão para dificultar que um usuário consiga ter
 * acesso ao mesmo. Entretanto qualquer regra de restrição aplicada no frontend deve ser validada no backend!!!
 */

function setObject(key, value, encryptKey) {
  try {
    memoizeCache.clear();
    return sessionStorage.setItem(
      key,
      encrypt(encodeURIComponent(JSON.stringify(value)), encryptKey)
    );
  } catch (e) {
    console.log(`Erro ao setar o objeto no sessionStore: ${e}`);
    return undefined;
  }
}

const getObject = memoize(
  (key, encryptKey) => {
    try {
      const value = sessionStorage.getItem(key);
      if (value)
        return JSON.parse(decodeURIComponent(decrypt(value, encryptKey)));
      return value;
    } catch (e) {
      console.log(`Erro ao buscar o objeto no sessionStore: ${e}`);
      return undefined;
    }
  },
  { cache: { create: () => memoizeCache } }
);

export const Sessao = (key) => {
  var token = getObject(ACCESS_TOKEN, TOKEN_ENCRYPT_KEY);
  if (token) {
    return token[key];
  }
};

export const setSessaoToken = (token) =>
  setObject(ACCESS_TOKEN, token, TOKEN_ENCRYPT_KEY);

export const limparSessao = () => {
  delete sessionStorage[ACCESS_TOKEN];
  delete sessionStorage["profilePicture"];
  sessionStorage.clear();
};

/* Caso esteja em desenvolvimetno exporta a função Sessao, para facilitar a depuração */
if (process.env.NODE_ENV === "development") {
  window["GetSessao"] = function () {
    return getObject(ACCESS_TOKEN, TOKEN_ENCRYPT_KEY);
  };

  window["SetSessao"] = function (obj) {
    setObject(ACCESS_TOKEN, obj, TOKEN_ENCRYPT_KEY);
  };

  window["EACache"] = () => memoizeCache;
}
